<router-outlet></router-outlet>

@if (alertState(); as alert) {
  <div class="global-error-overlay" (click)="clearAlert()">
    <div class="error-toast" [class.info]="alert.type === 'info'" [class.success]="alert.type === 'success'" (click)="$event.stopPropagation()">
      <div class="error-icon">
        @if (alert.type === 'error') {
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        } @else {
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }
      </div>
      <div class="error-content">
        <h3>{{ alert.title }}</h3>
        <p>{{ alert.message }}</p>
        <div class="error-actions">
          <button type="button" class="btn-error-ok" (click)="clearAlert()">OK</button>
        </div>
      </div>
      <button type="button" class="close-toast-btn" (click)="clearAlert()">×</button>
    </div>
  </div>
}

@if (isLoading()) {
  <div class="global-loader-overlay">
    <div class="loader-spinner"></div>
    <div class="loader-text">Loading...</div>
  </div>
}